import { Env } from '@env';
import { Platform } from 'react-native';

// Subdomains that are NOT white-label organizations and should resolve to the
// normal eon experience.
const RESERVED_SUBDOMAINS = new Set(['', 'www', 'app', 'agent', 'staging']);

/**
 * Derives the white-label organization slug from the current web hostname.
 *
 * The organization is pure derived state from the URL, so this is the single
 * place that parses it. Examples (with the matching `Env.HOSTNAME`):
 *   xyz.app.anonrides.com          (HOSTNAME=app.anonrides.com)         -> "xyz"
 *   abc.staging.app.anonrides.com  (HOSTNAME=staging.app.anonrides.com) -> "abc"
 *   abc.localhost:81               (HOSTNAME=localhost)                 -> "abc"
 *   app.anonrides.com              (apex / main site)                   -> null
 *
 * Returns null on native (no subdomain) and on the apex domain.
 */
export function getOrganizationSlug(): string | null {
  if (Platform.OS !== 'web') return null;

  const host = window.location.hostname; // excludes the port
  const base = Env.HOSTNAME;

  // Apex domain (or an unexpected host) -> main eon site.
  if (host === base || !host.endsWith(base)) return null;

  // Strip the base domain suffix, then take the first label.
  const prefix = host.slice(0, host.length - base.length).replace(/\.$/, '');
  const slug = prefix.split('.')[0].toLowerCase();

  return RESERVED_SUBDOMAINS.has(slug) ? null : slug;
}
